import { render, staticRenderFns } from "./FiltersBar.vue?vue&type=template&id=04f2b53a"
import script from "./FiltersBar.vue?vue&type=script&lang=js"
export * from "./FiltersBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports